import { useSelector } from "react-redux"
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
const Checkoutsuccess = () => {
    const navigate=useNavigate()
    const auth = useSelector((state) => state.auth);
    console.log(auth)

    return ( <div>
             
              <div className="Notfound">
              <h2>Payment Success </h2><br></br>
              <h3><p><View onClick={() => navigate(`/userorder/${auth._id}`)}>View Orders</View></p></h3><br></br>
              <p><View1 onClick={() => navigate("/")}>Contniue Shopping</View1></p>
               </div>
            </div>);
}
 
export default Checkoutsuccess;
const View = styled.button`
  background-color: yellow;

  color: black;
  font-size:25px;

`;
const View1 = styled.button`
  background-color: rgb(114, 225, 40);

  color: black;
  font-size:25px;

`;